<template>
  <div>

    <form action="" class="mb-3 border-bottom-grey">
      <div class="form-row">
        <div class="col-md-7">
          <!--          <label for="filter">{{$t('message.show_results_by_demographic')}}</label>-->
          <select @change="changeHandler"
                  name="demfilter"
                  id="demfilter"
                  class="form-control styled-input">
            <option
              v-for="(filter,i)  in filters"
              v-bind:key=i
              :selected="i === selectedFilterIndex"
              :disabled="!filter.field"
              :value="filter.field">
              {{filter.label}}
            </option>
          </select>
        </div>

        <div class="col-md-12">

        </div>
      </div>
    </form>
    <div class="results row">

      <template v-for="demographic in demographicsSorted">
        <team-card
          :vitamins="vitamins"
          :vitaminScores="vitaminScores"
          @clickedTeam="clickedTeam"
          class="col-md-6"
          v-if="demographic.data.children.length"

          v-bind:key="demographic.id"
          :data-id="demographic.id"
          :team="demographic">

        </team-card>
<!--        <pre class="text-white" style="max-height:300px; overflow:scroll">-->
<!--                                  {{demographic.data}}-->
<!--                                </pre>-->
      </template>

      <!--      <template v-for="dem in demographics">-->
      <!--    <pre class="text-white" style="max-height:300px; overflow:scroll">-->
      <!--                  {{dem}}-->
      <!--                </pre>-->
      <!--      </template>-->
      <!--      <team-review :team="demographic"></team-review>-->
    </div>

  </div>

</template>
<script>
  import TeamReview from './TeamReview'
  import store from "../../store/store";
  import TeamCard from './TeamCard'

  function splitYears(bracket) {
    let start = bracket.split('-');
    if (start.length === 1) {
      start = start.join().split('+')[0]
    }
  //  console.log('start', start);
    return parseInt(start)
  }

  export default {
    components: {
      TeamCard,
      TeamReview
    },
    computed: {
      demographicsSorted() {
        return _.sortBy(this.demographics, [dem => dem.orderIndex])
      },
      countries() {
        let countries = [];
        this.allCountries.forEach(country => {
          countries.push({
            key: country,
            label: this.$t('message.country_' + country),
          })
        });
        return countries;
      },
      selectedFilter() {
        return this.filters[this.selectedFilterIndex]
      }
    },
    data() {
      return {
        demographics: [],
        selectedFilterIndex: 1,
        filters: [
          {
            field: '',
            values: [
              {key: null, label: this.$t('message.choose_a_demographic')},
            ],
            label: '-- ' + this.$t('message.choose_a_demographic') + ' --'
          },
          {
            field: 'country',
            values: this.countries,
            label: this.$t('message.country')
          },
          {
            field: 'gender',
            values: [
              {key: 'm', label: this.$t('message.male')},
              {key: 'v', label: this.$t('message.female')},
              {key: 'x', label: this.$t('message.other')},
            ],
            label: this.$t('message.gender')
          },
          {
            field: 'age',
            values: [
              {key: '18-24', label: '18-24'},
              {key: '25-34', label: '25-34'},
              {key: '35-44', label: '35-44'},
              {key: '45-54', label: '45-54'},
              {key: '55-64', label: '55-64'},
              {key: '65+', label: '65+'},
            ],
            label: this.$t('message.age')
          },
          {
            field: 'workingyears',
            values: [
              {key: '0-2', label: '0-2'},
              {key: '3-5', label: '3-5'},
              {key: '6-9', label: '6-9'},
              {key: '10-15', label: '10-15'},
              {key: '15-20', label: '15-20'},
              {key: '20+', label: '20+'},
            ],
            label: this.$t('message.years_seniority')
          },
          {
            field: 'education',
            values: [
              {key: 'primary', label: this.$t('message.primary')},
              {key: 'secondary', label: this.$t('message.secondary')},
              {key: 'bachelor', label: this.$t('message.bachelor')},
              {key: 'master', label: this.$t('message.master')},
              {key: 'doctorate', label: this.$t('message.doctorate')},
            ],
            label: this.$t('message.degree')
          },
        ]
      }
    },
    methods: {
      clickedTeam(team) {
        this.$emit('clickedTeam', team)
      },
      changeHandler(evt) {
        let type = evt.target.value;
        this.loadDemographic(type)
      },
      async loadDemographic(type) {
        this.demographics = [];

        //get all subtypes
        //for each subtype, get most recent
        let distinctTypes = {};
        const subtypes = await this.axios.get('/averages?type=' + type + '&date_gte=' + this.today);
        subtypes.data.forEach(subtype => {
          // console.log('subtype',subtype.subtype);
          distinctTypes[subtype.subtype] = subtype.subtype
        });
        distinctTypes = Object.keys(distinctTypes);
      //  console.log('available types', distinctTypes);

        distinctTypes.forEach(async subtype => {
          const results = await this.axios.get('/averages?type=' + type + '&subtype=' + subtype + '&_sort=date:DESC&_limit=1');
          let dem = results.data[0];
          if (dem) {
            if (!dem.subtype) {
              dem.subtype = 'null'
            }
            dem.orderIndex = splitYears(dem.subtype);
            this.demographics.push(dem);
          }
        });


        // let demrequest = '/averages?type=' + type + '&_sort=subtype:ASC&date_gte=' + this.today;
        // const demographics = await this.axios.get(demrequest);
        // this.demographics = demographics.data
      }
    },
    props: {
      vitaminScores: {
        type: Object,
        default() {
          return {}
        }
      },
      vitamins: {
        type: Array,
        default() {
          return []
        }
      }
    },
    created() {
      this.loadDemographic('country')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Review/Demographics.vue